module.exports = __webpack_public_path__ + "img/bg-seo.8daa4f9.jpg";